import { Avatar, Select, Tooltip, Typography} from 'antd';
import { SizeType } from 'antd/lib/config-provider/SizeContext';
import { DefaultOptionType } from 'antd/lib/select';
import User from '../../../models/User';
import { createInitialNames, truncateStringEllipsis } from '../../../utils/functions';
import './SelectUsers.less';

interface SelectUsersProps{
    placeholder: string;
    users: User[];
    onChange: ((value: string[], option: DefaultOptionType | DefaultOptionType[]) => void)
    avatarCount: number;
    value: string[];
    className: string;
    size?:  SizeType
}

const SelectUsers = (props: SelectUsersProps) => {

    const { Option } = Select;
    const { Text } = Typography;
    const { placeholder, users, onChange, size, avatarCount, value, className } = props

    const maxTagPlaceholder = (omittedValues:any) =>{
        return (
          <Avatar.Group maxCount={avatarCount} >
            {
              omittedValues.map((avatar:any, index: any)=>{
      
                const fullName = avatar.label.props.children[1].props.children;
                const initialName = avatar.label.props.children[0].props.children.props.children;
              
                return(
                  <Tooltip placement='top' title={fullName} key={index} id={'test'}>
                    <Avatar style={{ backgroundColor: '#0078A0' }}>
                      {initialName}
                    </Avatar>
                  </Tooltip>
                )
              })
            }
          </Avatar.Group>
        )
    }

    const tagRender = (props: any) => {

        const { label } = props;
        const fullName = label.props.children[1].props.children;
        const initialName = label.props.children[0].props.children;
      
        return (
            <Tooltip title={fullName} placement="top">
                <Avatar 
                  size={40}
                  style={{
                    color: '#FFFFFF',
                    backgroundColor: '#D9D9D9',
                  }}
                >{initialName}</Avatar>
            </Tooltip>
        );
    };
    
    return (
                <Select
                  mode="multiple"
                  className={className}
                  size={size ? size : 'large'}
                  placeholder={placeholder}
                  value={value}
                  allowClear
                  onChange={onChange}
                  maxTagCount={0}
                  maxTagPlaceholder = {maxTagPlaceholder}
                  tagRender={tagRender}
                  filterOption={(inputValue, option) => 
                    option!.label
                    ?.toString()
                    .toLowerCase()
                    .indexOf(inputValue.toLowerCase()) !== -1
                  }
                >
                  {users.map((user: User) => (
                    <Option
                      key={user.id}
                      value={user.id}
                      label={`${user.nombre} ${user.apellido}`}
                    >
                      <div className="ml-drop-filter__items__users__select">
                        <span role="img">
                          <Avatar
                            size={'large'}
                            style={{
                              color: '#FFFFFF',
                              backgroundColor: '#D9D9D9',
                            }}
                          >
                            {createInitialNames(user.nombre, user.apellido)}
                          </Avatar>
                        </span>
                        <Text title={`${user.nombre} ${user.apellido}`}>
                          {truncateStringEllipsis(`${user.nombre} ${user.apellido}`, 20)}
                        </Text>
                      </div>
                    </Option>
                  ))}
                </Select>
    )
}

export default SelectUsers;